@if (!useSummaryView) {
  @if (!field.hidden) {
    <div class="flex flex-col w-full" animate.enter="fade-in">
        <div class="flex flex-row items-center w-full mb-4" [ngClass]="{
            'justify-left': field.browserOpts.alignment === 'LEFT',
            'justify-center': field.browserOpts.alignment === 'CENTER',
            'justify-right': field.browserOpts.alignment === 'RIGHT'
        }">
        @if (field.browserOpts.inLineWithCaption) {
          <div class="mr-2">
            <div class="leading-6 font-medium">{{ field.label | localize }}</div>
            @if (field.hint) {
              <div class="text-md text-secondary">{{ field.hint | localize }}</div>
            }
          </div>
        }
        <div>
          @if (!field.browserOpts.inLineWithCaption) {
            <div class="mb-2">
              <div class="leading-6 font-medium">{{ field.label | localize }}</div>
              @if (field.hint) {
                <div class="text-md text-secondary">{{ field.hint | localize }}</div>
              }
            </div>
          }
          <mat-radio-group [formControl]="field.control">
            <mat-radio-button class="mr-4" [value]="trueValue">
              {{ field.trueLabel ? (field.trueLabel | localize) : ('yes' | transloco) }}
            </mat-radio-button>
            <mat-radio-button class="mr-4" [value]="falseValue">
              {{ field.falseLabel ? (field.falseLabel | localize) : ('no' | transloco) }}
            </mat-radio-button>
            <mat-radio-button [value]="unanswredValue">
              {{ field.emptyLabel ? (field.emptyLabel | localize) : ('unanswered' | transloco) }}
            </mat-radio-button>
          </mat-radio-group>
          @if (!field.readonly &&
            field.control.touched &&
            field.control.errors) {
            @if (field.control.hasError('required')) {
              <div
                class="text-sm text-warn leading-none font-medium mt-2">
                {{ 'errorRequiredField' | transloco }}
              </div>
            }
            @if (field.control.hasError('invalidValue')) {
              @switch (field.control.errors.invalidValue.required) {
                @case (trueValue) {
                  <div class="text-sm text-warn leading-none font-medium mt-2">
                    {{ 'errorRadioInvalidValue' | transloco:{ requiredValue: field.trueLabel ?
                    (field.trueLabel | localize) : ('yes' | transloco) } }}
                  </div>
                }
                @case (falseValue) {
                  <div class="text-sm text-warn leading-none font-medium mt-2">
                    {{ 'errorRadioInvalidValue' | transloco:{ requiredValue: field.falseLabel ?
                    (field.falseLabel | localize) : ('no' | transloco) } }}
                  </div>
                }
                @case (unanswredValue) {
                  <div class="text-sm text-warn leading-none font-medium mt-2">
                    {{ 'errorRadioInvalidValue' | transloco:{ requiredValue: field.emptyLabel ?
                    (field.emptyLabel | localize) : ('unanswered' | transloco) } }}
                  </div>
                }
              }
            }
          }
        </div>
      </div>
    </div>
  }
} @else {
  {{ (field.control.value === "TRUE" ? field.trueLabel : (field.control.value === "FALSE" ? field.falseLabel : (field.control.value === "UNANSWERED" ?
  field.emptyLabel : ""))) | localize }}
}

